import {Action, Card, useDialog} from 'platform/components';

import {useDispatch} from 'react-redux';

import {mergeAll} from 'ramda';

import {documentContextApi, useGetTireOrderQuery} from '@dms/api/core';
import {
  DOCUMENT_ACTION_COLUMNS,
  useGetDocumentDatagridActions,
} from '@dms/features/document-context';
import i18n from '@dms/i18n';
import {testIds} from '@dms/routes';
import {DmsDataGrid, refreshDmsDatagrid, Section, UploadDocumentsDialog} from '@dms/shared';

import {buildArray} from 'shared/web';

import type {QueryFilterObject} from 'features/eag-grid';

import {useTiresInventoryUrl} from '../../hooks/useTiresInventoryUrl';

export function TireOrderDocuments() {
  const {orderId} = useTiresInventoryUrl();

  const [isUploadDialogOpen, openUploadDialog, closeUploadDialog] = useDialog();

  const dispatch = useDispatch();

  const {data: tireOrder} = useGetTireOrderQuery({orderId});

  const [actionCallback, bulkSignatureAction] = useGetDocumentDatagridActions({
    contextId: orderId,
    contextTarget: 'tire-order',
    refreshData: () => refreshDmsDatagrid('document-context-list-tire-order'),
    customerId: tireOrder?.customerId,
  });

  const queryModifier = (filter: QueryFilterObject) => mergeAll([filter, {tireOrderId: orderId}]);

  const onDocumentCreated = () => {
    refreshDmsDatagrid('document-context-list-tire-order');

    dispatch(documentContextApi.util.invalidateTags([{type: 'documentsCount', id: orderId ?? ''}]));
  };

  return (
    <Section data-testid={testIds.tiresInventory.tireOrderDetail('documents')}>
      <Card
        title={i18n.t('page.customer.documents.title')}
        actions={buildArray<Action>([
          {
            variant: 'link',
            type: 'button',
            leftIcon: 'action/backup',
            onClick: openUploadDialog,
            title: i18n.t('entity.document.actions.uploadDocument'),
          },
        ]).add(...bulkSignatureAction)}
      >
        <DmsDataGrid
          autoHeight
          gridCode="document-context-list-tire-order"
          actionCallback={actionCallback}
          predefinedColumns={DOCUMENT_ACTION_COLUMNS}
          data-testid={testIds.tiresInventory.tireOrderDetail('documents')}
          emptyState={{
            headline: i18n.t('page.customer.notifications.noDocuments'),
            subheadline: i18n.t('page.customer.notifications.documentListWillAppearHere'),
          }}
          queryModifier={queryModifier}
        />
      </Card>
      <UploadDocumentsDialog
        isOpen={isUploadDialogOpen}
        handleClose={closeUploadDialog}
        onDocumentCreated={onDocumentCreated}
        contextTarget="tire-order"
        contextId={orderId}
      />
    </Section>
  );
}
